import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import {MatPaginator, MatSort} from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { of as observableOf} from 'rxjs/observable/of';
import {debounceTime, distinctUntilChanged, startWith, tap, delay} from 'rxjs/operators';
import {catchError, map, switchMap} from 'rxjs/operators';
import {merge} from 'rxjs/observable/merge';
import {fromEvent} from 'rxjs/observable/fromEvent';

import { VehiclesService} from '../../../_services/vehicles.service';
import {VehicleDataSource} from './vehicles.datasource';
import {IMultiSelectVehicleRow} from '../../../_models/vehicle';
import { PaginationParams } from '../../../_models/generic';


@Component({
  selector: 'app-dl-multi-select-vehicles',
  templateUrl: './dl-multi-select-vehicles.component.html',
  styleUrls: ['./dl-multi-select-vehicles.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DlMultiSelectVehiclesComponent implements OnInit {

  // selectedVehicles: Array<IMultiSelectVehicleRow> = [];

  dataSource: VehicleDataSource;
  displayedColumns: string[] = ['registration', 'id'];
  public defaultPageSize: number = 25;
  public pageDisplayOptions: Array<number> = [25, 50, 75, 100];

  @Input() selectedVehicles: Array<IMultiSelectVehicleRow>;
  @Input() labelText: string;
  @Output() outputSelectedVehicles = new EventEmitter<Array<IMultiSelectVehicleRow>>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('multiSelectSearch') tableSearchInput: ElementRef;

  constructor(private vehiclesService: VehiclesService) { }

  ngOnInit() {
    // Create new instance of datasource
    this.dataSource = new VehicleDataSource(this.vehiclesService);
    // Get first page of data
    this.loadInitialVehicles();
  }

  ngAfterViewInit() {

    // server-side search
    fromEvent(this.tableSearchInput.nativeElement, 'keyup')
        .pipe(
            debounceTime(150),
            distinctUntilChanged(),
            tap(() => {
                this.paginator.pageIndex = 0;
                this.loadVehiclePage();
            })
        )
        .subscribe();

    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // on sort or paginate events, load a new page
    merge(this.sort.sortChange, this.paginator.page)
    .pipe(
        tap(() => this.loadVehiclePage())
    )
    .subscribe();
  }

  public selectItem(item: IMultiSelectVehicleRow) {
    if ( this.isRowSelected(item.id) ) {
      return false;
    } else {
      this.selectedVehicles.push(item);
      this.outputSelectedVehicles.emit(this.selectedVehicles);
    }
  }

  public deSelectItem(index: number, item: IMultiSelectVehicleRow) {
    this.selectedVehicles.splice(index, 1);
    this.outputSelectedVehicles.emit(this.selectedVehicles);
  }
  public clearAllSelected() {
    this.selectedVehicles = [];
    this.outputSelectedVehicles.emit(this.selectedVehicles);
  }

  public isRowSelected(id: number) {
    const _found = this.selectedVehicles.some(function (el) {
      return el.id === id;
    });
    if (_found) {
      return true;
    }
    return false;
  }

  private clearTableSearch() {
    this.tableSearchInput.nativeElement.value = '';
    this.loadVehiclePage();
  }

  private loadInitialVehicles() {
    const _params: PaginationParams = {
      pageSize: 50,
      page: 1,
      orderingDirection: '',
      ordering: 'registration',
      search: ''
    };
    this.dataSource.loadAdminVehicles(_params);
  }

  private loadVehiclePage() {
    const _params: PaginationParams = {
      pageSize: this.paginator.pageSize,
      page: this.paginator.pageIndex + 1,
      orderingDirection: this.sort.direction,
      ordering:  this.sort.active,
      search: this.tableSearchInput.nativeElement.value
    };
    this.dataSource.loadAdminVehicles(_params);
  }


}






// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/dl-multi-select-vehicles/dl-multi-select-vehicles.component.ts